import { http, createConfig } from 'wagmi';
import { metaMask } from 'wagmi/connectors';

export const CRAT_TESTNET = {
  id: 1979,
  name: 'CratD2C Testnet',
  nativeCurrency: {
    decimals: 18,
    name: 'CRAT',
    symbol: 'CRAT',
  },
  rpcUrls: {
    default: {
      http: [
        'https://rpc-testnet-1.cratd2csmartchain.io',
        'https://rpc-testnet-2.cratd2csmartchain.io/',
        'https://rpc-testnet-3.cratd2csmartchain.io/',
      ],
    },
  },
  blockExplorers: {
    default: {
      name: 'CratD2C Explorer',
      url: 'https://explorer-testnet.cratd2csmartchain.io/',
    },
  },
};

export const config = createConfig({
  chains: [CRAT_TESTNET],
  connectors: [metaMask()],
  transports: {
    [CRAT_TESTNET.id]: http(),
  },
});
